import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '../../../src/assets/images/trip-advisor-rating.svg'
import _imports_1 from '../../../src/assets/images/karta.png'


const _hoisted_1 = { class: "hotels-search-card-info-header__stars-container" }
const _hoisted_2 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  alt: "trip-advisor-rating",
  class: "hotels-modal__tripadvisor-rating"
}, null, -1)
const _hoisted_3 = { class: "hotels-modal__title" }
const _hoisted_4 = { class: "hotels-modal-info" }
const _hoisted_5 = { class: "hotels-modal-info__visual-wrapper" }
const _hoisted_6 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  alt: "map"
}, null, -1)
const _hoisted_7 = { class: "hotels-modal-info__wrapper" }
const _hoisted_8 = { class: "hotels-modal-info-descr" }
const _hoisted_9 = /*#__PURE__*/_createVNode("h3", { class: "hotels-modal-info-descr__title" }, "Краткое описание", -1)
const _hoisted_10 = {
  key: 0,
  class: "hotels-modal-info-descr__text"
}
const _hoisted_11 = /*#__PURE__*/_createStaticVNode("<section class=\"hotels-modal-info-descr\"><h3 class=\"hotels-modal-info-descr__title\"> Услуги и удобства в отеле </h3><ul class=\"hotels-modal-info-descr__services-list\"><li class=\"hotels-modal-info-descr__services-item hotels-modal-info-descr__services-item--ice\"> Кондиционер в номере </li><li class=\"hotels-modal-info-descr__services-item hotels-modal-info-descr__services-item--knife\"> Возможность заказть еду </li><li class=\"hotels-modal-info-descr__services-item hotels-modal-info-descr__services-item--news\"> Бесплатная пресса </li><li class=\"hotels-modal-info-descr__services-item hotels-modal-info-descr__services-item--wash\"> Косметика в номере </li><li class=\"hotels-modal-info-descr__services-item hotels-modal-info-descr__services-item--internet\"> Бесплатный Wi-Fi </li><li class=\"hotels-modal-info-descr__services-item hotels-modal-info-descr__services-item--bed\"> Белье в номере </li></ul></section>", 1)
const _hoisted_12 = { class: "hotels-modal-info-descr" }
const _hoisted_13 = /*#__PURE__*/_createVNode("h3", { class: "hotels-modal-info-descr__title" }, "Информация об отеле", -1)
const _hoisted_14 = { class: "hotels-modal-info-descr__address-list" }
const _hoisted_15 = { class: "hotels-modal-info-descr__address-item" }
const _hoisted_16 = {
  key: 0,
  href: "#",
  class: "hotels-modal-info-descr__address-link hotels-modal-info-descr__address-link--address"
}
const _hoisted_17 = { class: "hotels-modal-info-descr__address-item" }
const _hoisted_18 = { class: "hotels-modal-info-descr__address-item" }
const _hoisted_19 = { key: 0 }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Galleria = _resolveComponent("Galleria")
  const _component_accesor_room_filter = _resolveComponent("accesor-room-filter")
  const _component_hotels_modal_card = _resolveComponent("hotels-modal-card")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock("div", null, [
    (_ctx.item)
      ? (_openBlock(), _createBlock(_component_Dialog, {
          key: 0,
          visible: _ctx.localDisplay,
          "onUpdate:visible": _cache[1] || (_cache[1] = $event => (_ctx.localDisplay = $event)),
          dismissableMask: true,
          class: "p-dialog--hotels",
          modal: true,
          onShow: _ctx.getPricing
        }, {
          header: _withCtx(() => [
            _createVNode("ul", _hoisted_1, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.item.stars, (star) => {
                return (_openBlock(), _createBlock("li", {
                  class: "hotels-search-card-info-header__stars-icon",
                  key: star.index
                }))
              }), 128 /* KEYED_FRAGMENT */))
            ]),
            _createVNode("h3", null, _toDisplayString(_ctx.item.hotelName.bs.rus), 1)
          ]),
          default: _withCtx(() => [
            _hoisted_2,
            _createVNode("h2", _hoisted_3, _toDisplayString(_ctx.item.hotelName.bs.rus), 1),
            _createVNode("div", _hoisted_4, [
              _createVNode("div", _hoisted_5, [
                _createVNode(_component_Galleria, {
                  value: _ctx.images,
                  showThumbnails: true,
                  showThumbnailNavigators: false,
                  numVisible: 5,
                  containerStyle: "max-width: 320px;",
                  showItemNavigators: true
                }, {
                  item: _withCtx((slotProps) => [
                    _createVNode("img", {
                      src: slotProps.item.itemImageSrc,
                      alt: slotProps.item.alt,
                      style: {"width":"100%","border-radius":"4px"}
                    }, null, 8, ["src", "alt"])
                  ]),
                  thumbnail: _withCtx((slotProps) => [
                    _createVNode("img", {
                      src: slotProps.item.thumbnailImageSrc,
                      alt: slotProps.item.alt,
                      style: {"width":"100%","border-radius":"4px"}
                    }, null, 8, ["src", "alt"])
                  ]),
                  _: 1
                }, 8, ["value"]),
                _hoisted_6
              ]),
              _createVNode("div", _hoisted_7, [
                _createVNode("section", _hoisted_8, [
                  _hoisted_9,
                  (_ctx.extendedHotelInfo)
                    ? (_openBlock(), _createBlock("p", _hoisted_10, _toDisplayString(_ctx.extendedHotelInfo.hotelDescription.bs.rus), 1))
                    : _createCommentVNode("", true)
                ]),
                _hoisted_11,
                _createVNode("section", _hoisted_12, [
                  _hoisted_13,
                  _createVNode("ul", _hoisted_14, [
                    _createVNode("li", _hoisted_15, [
                      (_ctx.extendedHotelInfo)
                        ? (_openBlock(), _createBlock("a", _hoisted_16, [
                            _createVNode("span", null, _toDisplayString(_ctx.extendedHotelInfo.hotelAddress.bs.rus), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _createVNode("li", _hoisted_17, [
                      (_ctx.extendedHotelInfo)
                        ? (_openBlock(), _createBlock("a", {
                            key: 0,
                            href: `tel:${_ctx.extendedHotelInfo.phone}`,
                            class: "hotels-modal-info-descr__address-link hotels-modal-info-descr__address-link--tel"
                          }, [
                            _createVNode("span", null, _toDisplayString(_ctx.extendedHotelInfo.phone), 1)
                          ], 8, ["href"]))
                        : _createCommentVNode("", true)
                    ]),
                    _createVNode("li", _hoisted_18, [
                      (_ctx.extendedHotelInfo)
                        ? (_openBlock(), _createBlock("a", {
                            key: 0,
                            href: `mailto:${_ctx.extendedHotelInfo.email}`,
                            class: "hotels-modal-info-descr__address-link hotels-modal-info-descr__address-link--mail"
                          }, [
                            _createVNode("span", null, _toDisplayString(_ctx.extendedHotelInfo.email), 1)
                          ], 8, ["href"]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ])
            ]),
            _createVNode(_component_accesor_room_filter, {
              roomAccesor: _ctx.roomAccesor,
              setService: _ctx.setService
            }, null, 8, ["roomAccesor", "setService"]),
            (_ctx.rooms)
              ? (_openBlock(), _createBlock("div", _hoisted_19, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.rooms, (room) => {
                    return _withDirectives((_openBlock(), _createBlock(_component_hotels_modal_card, {
                      key: room.uniqueAccessCode,
                      room: room,
                      select: _ctx.select,
                      unselect: _ctx.unselect,
                      class: { selected: _ctx.isSelect(room.uniqueAccessCode) },
                      isSelected: _ctx.isSelect(room.uniqueAccessCode)
                    }, null, 8, ["room", "select", "unselect", "class", "isSelected"])), [
                      [_vShow, _ctx.showRoom(room)]
                    ])
                  }), 128 /* KEYED_FRAGMENT */))
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["visible", "onShow"]))
      : _createCommentVNode("", true)
  ]))
}